<ion-header *ngIf="!device.isMobile()">
  <ion-toolbar>
    <ion-title>{{"PUZZLE.update_notification_modal.title" | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid class="puzzle-modal-grow">
    <ion-row *ngIf="puzzleUpdateNotifications.unreadUpdateNotifications.length">
      <ion-col>
        <ion-item lines="full">
          <ion-text color="primary">
            <h2>{{"PUZZLE.update_notification_modal.unread_text" | translate }}</h2>
          </ion-text></ion-item>
        <ion-list class="full-width"
                  *ngFor="let updateNotification of puzzleUpdateNotifications.unreadUpdateNotifications; index as i"
                  [class.collapsed]="triggeredUnreadAccordions[i]">
          <ion-list-header lines="none">
            <ion-label>{{updateNotification.date | localizedDate }}</ion-label>
            <ion-button (click)="triggeredUnreadAccordions[i] = !triggeredUnreadAccordions[i]">
              <ion-icon [name]="!triggeredUnreadAccordions[i] ? 'chevron-up-sharp' : 'chevron-down-sharp'"></ion-icon>
            </ion-button>
          </ion-list-header>
          <ion-item class="update-item" lines="none" *ngFor="let update of updateNotification.notifications">{{update.text}}</ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="puzzleUpdateNotifications.readUpdateNotifications.length">
      <ion-col>
        <ion-item lines="full">
          <ion-text color="primary">
            <h2>{{"PUZZLE.update_notification_modal.read_text" | translate }}</h2>
          </ion-text>
        </ion-item>
        <ion-list class="full-width" *ngFor="let updateNotification of puzzleUpdateNotifications.readUpdateNotifications; index as i"
                  [class.collapsed]="triggeredReadAccordions[i]">
          <ion-list-header lines="none">
            <ion-label>{{updateNotification.date | localizedDate }}</ion-label>
            <ion-button (click)="triggeredReadAccordions[i] = !triggeredReadAccordions[i]">
              <ion-icon [name]="!triggeredReadAccordions[i] ? 'chevron-up-sharp' : 'chevron-down-sharp'"></ion-icon>
            </ion-button>
          </ion-list-header>
          <ion-item class="update-item" lines="none" *ngFor="let update of updateNotification.notifications">{{update.text}}</ion-item>

        </ion-list>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<!--<ion-footer *ngIf="puzzleUpdateNotifications.hasUpdates">-->
<!--  <ion-item lines="none" class="full-width">-->
<!--    <ion-label>Als gelesen markieren</ion-label>-->
<!--    <ion-checkbox slot="start" [(ngModel)]="markAsReadChecked"></ion-checkbox>-->
<!--  </ion-item>-->
<!--</ion-footer>-->

<ion-footer>
  <div class="puzzle-modal-buttons">
    <ion-button color="primary"
                (click)="closeDialog(false)" fill="solid">
      <span>{{"PUZZLE.update_notification_modal.button.back" | translate }}</span>
      <ion-icon slot="start" name="backspace-sharp"></ion-icon>
    </ion-button>
    <ion-button color="primary" *ngIf="puzzleUpdateNotifications.hasUpdates"
                (click)="closeDialog(true)" fill="solid">
      <span>{{"PUZZLE.update_notification_modal.button.mark_as_read" | translate }}</span>
      <ion-icon slot="end" name="eye-sharp"></ion-icon>
    </ion-button>
  </div>
</ion-footer>

